import { faWarning } from "@fortawesome/free-solid-svg-icons";
import WarningMessage from "~/features/common/components/WarningMessage/WarningMessage";
import Icon from "~/features/common/components/icons/Icon/index";
import { useGetVersionQuery } from "~/generated/graphql";
import { version } from "../../../../../../appVersion.json";

const ApiVersionCheck = ({ collapsed }: { collapsed: boolean }) => {
  const { data, isLoading } = useGetVersionQuery();
  const runningApiVersion = data?.version;
  if (isLoading) {
    return null;
  }

  if (!runningApiVersion) {
    return null;
  }

  const warningMessageText = `API Version Mismatch! <br />
<strong>Required: ${version} </strong><br />
Server: ${runningApiVersion}`;
  if (runningApiVersion !== version) {
    return !collapsed ? (
      <WarningMessage classNames="my-2 mx-1" level="yellow" textSize="text-xs">
        <span>
          API Version Mismatch! <br />
          <strong>Required: {version} </strong>
          <br />
          Server: {runningApiVersion}
        </span>
      </WarningMessage>
    ) : (
      <span className="my-3 flex justify-center text-amber-500">
        <Icon html={warningMessageText} icon={faWarning} />
      </span>
    );
  }
  return null;
};

export default ApiVersionCheck;
